// extracted by mini-css-extract-plugin
module.exports = {"button":"Favorite_button__shPHZ","test":"Favorite_test__M5oGb"};